import styled from '@emotion/styled';

export const ShortEventListItem = styled('li', { label: 'ShortEventListItem' })`
    align-items: center;
    border-top: 1px solid #bbb;
    display: flex;
    flex-flow: row nowrap;
    padding: 10px;
    &:nth-of-type(2n) {
        background: #f5f5f5;
    }
    &:last-of-type {
        border-bottom: 1px solid #bbb;
    }
`;

export const ListOpenIcon = styled('button', { label: 'ListOpenIcon' })<{isActive: boolean}>`
    background: ${({isActive}): string => isActive === true  ? '#99cc00' : '#bbb'};
    border-radius: 50%;
    border: none;
    color: #fff;
    cursor: pointer;
    flex: 0 0 18px;
    height: 18px;
    margin-right: 10px;
    text-align: center;
    text-decoration: none;
    width: 18px;
    &:hover {
        background: #99cc00;
        color: #fff;
    }
`;

export const ListItemShortcut = styled('span', { label: 'ListItemShortcut' })`
    margin: 0 10px;
    text-align: left;
    width: 44px;
    flex: 0 0 44px;
`;

export const ListCompetitionName = styled('span', { label: 'ListCompetitionName' })`
    font-size: 11px;
    line-height: 1;
    font-weight: 300;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;

export const ListItemName = styled('strong', { label: 'ListItemName' })`
    display: block;
    font-size: 15px;
    line-height: 1;
    font-weight: 300;
    text-overflow: ellipsis;
    overflow: hidden;
`;
